module.exports = __webpack_public_path__ + "img/cafe-luso.c36a1549.jpg";